import {STORAGE_STATE_KEY as storageKey} from 'shared/const';
import {storageProxy} from 'interactors/storageProxy';

export function saveState(
  newSettings: Partial<StorableState>,
  storage: StorageService = storageProxy
): void {
  const savedState = storage.getItem(storageKey);

  storage.setItem(storageKey, {
    ...savedState,
    ...newSettings,
  });
}
